import { ShippingMethodsResponse } from '@/types/commercetools';
import { AppError } from '@/utility/errorClasses';
import { get, toQueryString } from '@/utility/requestHelpers/clientRequestHelpers';

export const fetchShippingMethods = async (
  cartId: string,
  countryCode: string
): Promise<ShippingMethodsResponse | null> => {
  try {
    const query = toQueryString({ countryCode: countryCode.toUpperCase() });
    return await get<ShippingMethodsResponse>(`/api/v1/carts/${cartId}/shippingMethods?${query}`);
  } catch (error) {
    // IF cart is not found, we ignore the error and return null.
    if (error instanceof AppError && error.statusCode === 404) {
      return null;
    }
    throw error;
  }
};
